import { Text } from "@chakra-ui/react";

// Función para armar la frase de 'No se encontraron desarrollos de acuerdo a los filtros aplicados (Inicialmente pensada para las paginas de Ciudades)
const getNoResultsText = (params) => {
    const {
        operation,
        type,
        city,
        neighborhood,
        state,
        bedrooms,
        bathrooms,
        halfBathrooms,
        parkingLots,
        price,
        searchKeyword,
    } = params;

    const phrases = [];

    // Tipo de operación
    if (operation?.length) {
        const ops = operation.map((op) => {
            if (op === "SALE") return "en venta";
            if (op === "LEASE") return "en renta";
            if (op === "PRESALE") return "en preventa";
            return op.toLowerCase();
        });
        phrases.push(`propiedades ${ops.join(", ")}`);
    }

    // Tipo de inmueble
    if (type?.length) {
        const types = type
            .map((t) => {
                switch (t) {
                    case "HOUSE":
                        return "casas";
                    case "APARTMENT":
                        return "departamentos";
                    case "TERRAIN":
                        return "terrenos";
                    case "OFFICE":
                        return "oficinas";
                    case "WAREHOUSE":
                        return "bodegas";
                    case "SHOP_SHOPPING_CENTER":
                        return "locales comerciales";
                    default:
                        return ""; // se filtra más abajo
                }
            })
            .filter(Boolean); // Elimina '' y valores falsy

        if (types.length) {
            phrases.push(`tipo ${types.join(", ")}`);
        }
    }

    // Ubicación
    const locationParts = [neighborhood, city, state].filter(Boolean);
    if (locationParts.length) {
        phrases.push(`en ${locationParts.join(", ")}`);
    }

    // Características
    if (bedrooms) {
        phrases.push(`${bedrooms} recámara(s)`);
    }
    if (bathrooms) {
        phrases.push(`${bathrooms} baño(s)`);
    }
    if (halfBathrooms) {
        phrases.push(`${halfBathrooms} medio baño(s)`);
    }
    if (parkingLots) {
        phrases.push(`${parkingLots} lugar(es) de estacionamiento`);
    }

    // Rango de precios
    if (price?.length === 2) {
        phrases.push(
            `con un precio entre $${Number(price[0]).toLocaleString()} y $${Number(price[1]).toLocaleString()}`
        );
    }

    // Palabra clave
    if (searchKeyword?.length) {
        phrases.push(`relacionado con "${searchKeyword.join(", ")}"`);
    }

    return (
        <Text textAlign="center" fontSize={{ base: "md", md: "lg" }}>
            Lo sentimos, no pudimos encontrar ningún resultado para{" "}
            <strong>{phrases.join(", ")}</strong>.
        </Text>
    );
};

export default getNoResultsText;
